/**
 * Warstwa API: rozdział modułów IT/HR i „Przenieś do modułu…” — polecenie właściciela 2026-10-03 (DZ-8).
 *
 * „Nie może być tak, że coś wysłane na it@krosno.com wpada na ticket HR albo odwrotnie (…) jest jedno zgłoszenie w HR, które
 * było wysłane na IT i nie da się go przenieść do IT.” Moduł zgłoszenia wynika ze skrzynki, na którą przyszło; zmiana modułu
 * to jawna czynność w oknie zgłoszenia.
 *
 * Trasy backendu:
 *  • `GET  tickets/{id}/przenies-do-modulu` — moduły, do których zalogowany może przenieść zgłoszenie
 *    `{ biezacyKod, biezacyNazwa, moduly: [{ id, kod, nazwa, maSkrzynkeWejsciowa, skrzynka, powod }] }`,
 *  • `POST tickets/{id}/przenies-do-modulu` `{ modulKod, categoryId }` — przeniesienie; 400 (zdanie), 403, 409
 *    `{ code: "modul_bez_skrzynki", message }`; 200 `{ message, modulNazwa, skrzynka, categoryName, zdjetePrzypisania[] }`,
 *  • `GET  tickets/rozjazdy-modulow` — zgłoszenia z kategorią innego modułu niż skrzynka (nic nie jest przenoszone samo).
 */
export function attach(api) {
    return {
        /** @param {string} ticketId */
        getModulyDoPrzeniesienia: (ticketId) =>
            api.get(`/tickets/${encodeURIComponent(ticketId)}/przenies-do-modulu`),
        /**
         * @param {string} ticketId
         * @param {{ modulKod: string, categoryId: string }} dane
         */
        przeniesDoModulu: (ticketId, dane) =>
            api.post(`/tickets/${encodeURIComponent(ticketId)}/przenies-do-modulu`, dane),
        getRozjazdyModulow: () => api.get("/tickets/rozjazdy-modulow"),
        /**
         * [poprawki DZ-8] Deski z flagą `innyModul` dla TEGO zgłoszenia (`GET tickets/desks?ticketId=`): desk, którego skrzynka
         * zmieniłaby moduł zgłoszenia, karta wyszarza — serwer i tak odmówi (moduł zmienia się tylko „Przenieś do modułu…”).
         * @param {string} ticketId
         */
        getDeskiZgloszenia: (ticketId) => api.get("/tickets/desks", { params: { ticketId } }),
    };
}
